import { Component, EventEmitter, Input, OnInit, Output, QueryList, ViewChildren } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiModulesService } from 'src/app/api-modules.service';
import { NgbdSortableHeader, SortEvent } from 'src/app/shared/directives/NgbdSortableHeader';
import { TableService } from 'src/app/shared/service/table.service';
import { LISTPAGEDB, ListPagesDB } from 'src/app/shared/tables/list-pages';
import { DecimalPipe } from '@angular/common';
//import { Channel } from 'diagnostics_channel';

@Component({
  selector: 'app-channelmessage',
  templateUrl: './channelmessage.component.html',
  styleUrls: ['./channelmessage.component.scss'],
  providers: [TableService, DecimalPipe]
})
export class ChannelmessageComponent implements OnInit {
  
  
  //channels: Channel[] = [];
  
  public selected = [];
  public tableItem$: Observable<ListPagesDB[]>;
  public searchText;
  public editID:any;
   visible:any=true;
  total$: Observable<number>;
  public getmessages:ListPagesDB[] = [];
  public  username=[];
  page = 1;
  pageSize = 50;
 
  @Input()id=[];
  @Output() visibleParentPage:EventEmitter<any>=new EventEmitter<any>();
  getviewmessagerequest: any;

  constructor(private ApiModulesService: ApiModulesService,public service: TableService) {
    this.tableItem$ = service.tableItem$;
    this.total$ = service.total$;
    this.service.setUserData(LISTPAGEDB);
  }
   @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;

   onSort({ column, direction }: SortEvent) 
   {
     console.log(this);
     this.headers.forEach((header) => 
     {
       if (header.sortable !== column) 
       {
         header.direction = '';
       }
     });
 
     this.service.sortColumn = column;
     this.service.sortDirection = direction;
 
   }
 
   onSelect({ selected }) {
     this.selected.splice(0, this.selected.length);
     this.selected.push(...selected);
   }
  
  ngOnInit(): void {
   this.getchannelmessage();
  }

    public getchannelmessage(){
        this.ApiModulesService.get('telegram/channel/extern-channel-message').subscribe((data)=>{
            this.getmessages=data;
             console.log(this.getmessages);
        });
    }

    public  viewmessage(id){
      this.editID=id;
      this.visible=false;
      }
 
  
  childEmitted(data:any){
    //  console.log(data);
    this.visible=data;
    this.getchannelmessage();

  }

}

